import createLucideIcon from '../createLucideIcon';

/**
 * @component @name BookLock
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxOS41di0xNUEyLjUgMi41IDAgMCAxIDYuNSAySDEwIiAvPgogIDxwYXRoIGQ9Ik0yMCAxNXY3SDYuNWEyLjUgMi41IDAgMCAxIDAtNUgyMCIgLz4KICA8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB4PSIxMiIgeT0iNiIgcng9IjEiIC8+CiAgPHBhdGggZD0iTTE4IDZWNGEyIDIgMCAxIDAtNCAwdjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/book-lock
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const BookLock = createLucideIcon('BookLockIcon', [
  ['path', { d: 'M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10', key: '18wgow' }],
  ['path', { d: 'M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20', key: 'dpch1j' }],
  ['rect', { width: '8', height: '5', x: '12', y: '6', rx: '1', key: '9nqwug' }],
  ['path', { d: 'M18 6V4a2 2 0 1 0-4 0v2', key: '1aquzs' }],
]);

export default BookLock;
